import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box
} from '@mui/material';

const TriggerForm = ({ open, onClose, onSubmit, trigger, isEdit }) => {
  const [formData, setFormData] = useState({
    name: '',
    key: '',
    description: ''
  });

  useEffect(() => {
    if (trigger) {
      setFormData({
        name: trigger.name || '',
        key: trigger.key || '',
        description: trigger.description || ''
      });
    } else {
      setFormData({
        name: '',
        key: '',
        description: ''
      });
    }
  }, [trigger]);

  const handleChange = (field) => (event) => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(formData);
  };

  const handleClose = () => {
    setFormData({
      name: '',
      key: '',
      description: ''
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {isEdit ? 'Edit Trigger' : 'Create New Trigger'}
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Trigger Name"
              value={formData.name}
              onChange={handleChange('name')}
              fullWidth
              required
              variant="outlined"
            />
            <TextField
              label="Trigger Key"
              value={formData.key}
              onChange={handleChange('key')}
              fullWidth
              required
              variant="outlined"
              placeholder="unique_key_name"
              helperText="Unique identifier for the trigger (e.g., 'player_joins', 'item_purchased')"
            />
            <TextField
              label="Description"
              value={formData.description}
              onChange={handleChange('description')}
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              placeholder="Describe what this trigger does..."
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            Cancel
          </Button>
          <Button type="submit" variant="contained">
            {isEdit ? 'Update' : 'Create'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default TriggerForm; 